(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances = new WeakMap();

    class AnnouncementTicker {
      constructor(bar) {
        this.bar = bar;
        this.viewport = bar.querySelector('.ann__viewport');
        this.track = bar.querySelector('.ann__track');
        this.groups = Array.from(bar.querySelectorAll('.ann__group'));
        this.closeButton = bar.querySelector('[data-announcement-dismiss]');

        this.x = 0;
        this.groupWidth = 0;
        this.lastTime = 0;
        this.raf = 0;
        this.running = false;
        this.pausedByPointer = false;
        this.resizeRaf = 0;
        this.hasInitialPosition = false;

        /*
          Movement direction follows the page language:
          LTR pages move right -> left.
          RTL pages move left -> right.
        */
        const documentDir =
          (document.documentElement.getAttribute('dir') || '').toLowerCase();

        const localDir =
          (this.bar.closest('[dir]')?.getAttribute('dir') || '').toLowerCase();

        this.isRTL = (documentDir || localDir) === 'rtl';

        this.storageKey =
          `announcement-dismissed-${bar.dataset.announcementId || 'default'}`;

        this.onFrame = this.onFrame.bind(this);
        this.onResize = this.onResize.bind(this);
        this.onVisibility = this.onVisibility.bind(this);
        this.onClose = this.onClose.bind(this);
        this.onPointerEnter = this.onPointerEnter.bind(this);
        this.onPointerLeave = this.onPointerLeave.bind(this);

        this.init();
      }

      init() {
        try {
          if (sessionStorage.getItem(this.storageKey) === '1') {
            this.bar.hidden = true;
            return;
          }
        } catch (_) {}

        if (!this.viewport || !this.track || this.groups.length < 2) return;

        this.closeButton?.addEventListener('click', this.onClose);
        window.addEventListener('resize', this.onResize, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);

        /*
          Pause on hover only when the device really has a mouse/trackpad.
          Touch devices never attach these pause handlers.
        */
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
          this.bar.addEventListener('mouseenter', this.onPointerEnter);
          this.bar.addEventListener('mouseleave', this.onPointerLeave);
        }

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.onResize);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.groups[0]);
        }

        /*
          Wait until layout has a real width, then start.
          Retry a few frames because Shopify/mobile browsers can paint sections
          before fonts and final viewport sizing settle.
        */
        this.waitForLayout(0);
      }

      waitForLayout(attempt) {
        const width = this.groups[0]?.getBoundingClientRect().width || 0;
        const viewportWidth = this.viewport?.getBoundingClientRect().width || 0;

        if (width > 0 && viewportWidth > 0) {
          this.measure();
          this.start();
          return;
        }

        if (attempt < 120) {
          requestAnimationFrame(() => this.waitForLayout(attempt + 1));
        }
      }

      measure() {
        if (!this.groups[0]) return;

        const width = this.groups[0].getBoundingClientRect().width;
        if (!width) return;

        const previousWidth = this.groupWidth;
        this.groupWidth = width;

        /*
          The two physical groups are:
            [ group A ][ group B ]

          English/LTR starts at 0 and travels to -groupWidth.
          Arabic/RTL starts at -groupWidth and travels back to 0.

          Both endpoints show an identical group in the viewport, so the reset
          is invisible.
        */
        if (!this.hasInitialPosition) {
          this.x = this.isRTL ? -this.groupWidth : 0;
          this.hasInitialPosition = true;
        } else if (previousWidth > 0) {
          /*
            Preserve the relative position through resize/orientation changes.
          */
          let progress;

          if (this.isRTL) {
            progress = (this.x + previousWidth) / previousWidth;
            progress = Math.min(1, Math.max(0, progress));
            this.x = -this.groupWidth + (progress * this.groupWidth);
          } else {
            progress = (-this.x) / previousWidth;
            progress = Math.min(1, Math.max(0, progress));
            this.x = -(progress * this.groupWidth);
          }
        }

        this.applyTransform();
      }

      getPixelsPerSecond() {
        /*
          Existing rotate-speed theme setting:
          3 = faster, 12 = slower.
          The inline --ann-duration value is ignored by this JS engine.
        */
        const rawMs = Number(this.bar.dataset.rotateInterval || 0);
        const setting = rawMs ? rawMs / 1000 : 6;
        const clamped = Math.min(12, Math.max(3, setting));

        const isPhone = window.matchMedia('(max-width: 749px)').matches;

        if (isPhone) {
          return Math.max(30, 52 - ((clamped - 3) * 2.0));
        }

        return Math.max(34, 60 - ((clamped - 3) * 2.4));
      }

      start() {
        if (this.running || this.bar.hidden || !this.groupWidth) return;

        this.running = true;
        this.lastTime = performance.now();
        this.raf = requestAnimationFrame(this.onFrame);
      }

      stop() {
        this.running = false;
        cancelAnimationFrame(this.raf);
        this.raf = 0;
      }

      onFrame(now) {
        if (!this.running) return;

        /*
          Clamp large elapsed times so returning from another tab does not
          create a huge visible jump.
        */
        const deltaSeconds = Math.min(0.05, Math.max(0, (now - this.lastTime) / 1000));
        this.lastTime = now;

        if (!this.pausedByPointer && !document.hidden && this.groupWidth > 0) {
          const distance = this.getPixelsPerSecond() * deltaSeconds;

          if (this.isRTL) {
            /*
              Arabic/RTL: mirrored physical movement.
              The track travels left -> right:
                -groupWidth -> 0
              then resets to the identical frame at -groupWidth.
            */
            this.x += distance;

            while (this.x >= 0) {
              this.x -= this.groupWidth;
            }
          } else {
            /*
              English/LTR: right -> left:
                0 -> -groupWidth
            */
            this.x -= distance;

            while (this.x <= -this.groupWidth) {
              this.x += this.groupWidth;
            }
          }

          this.applyTransform();
        }

        this.raf = requestAnimationFrame(this.onFrame);
      }

      applyTransform() {
        if (!this.track) return;

        /*
          Valid seamless range for both languages is always:
            -groupWidth <= x <= 0
        */
        if (this.groupWidth > 0) {
          this.x = Math.max(-this.groupWidth, Math.min(0, this.x));
        }

        const transform = `translate3d(${this.x.toFixed(2)}px, 0, 0)`;

        /*
          Inline !important deliberately wins over theme CSS that may set
          transform:none on mobile/reduced-motion layouts.
        */
        this.track.style.setProperty('transform', transform, 'important');
        this.track.style.setProperty('-webkit-transform', transform, 'important');
      }

      onResize() {
        cancelAnimationFrame(this.resizeRaf);

        this.resizeRaf = requestAnimationFrame(() => {
          this.measure();

          if (!this.running && this.groupWidth) {
            this.start();
          }
        });
      }

      onVisibility() {
        if (!document.hidden) {
          this.lastTime = performance.now();
          this.measure();

          if (!this.running) this.start();
        }
      }

      onPointerEnter() {
        this.pausedByPointer = true;
      }

      onPointerLeave() {
        this.pausedByPointer = false;
        this.lastTime = performance.now();
      }

      onClose() {
        this.stop();

        try {
          sessionStorage.setItem(this.storageKey, '1');
        } catch (_) {}

        this.bar.hidden = true;
      }

      destroy() {
        this.stop();
        cancelAnimationFrame(this.resizeRaf);

        this.closeButton?.removeEventListener('click', this.onClose);
        window.removeEventListener('resize', this.onResize);
        document.removeEventListener('visibilitychange', this.onVisibility);

        this.bar.removeEventListener('mouseenter', this.onPointerEnter);
        this.bar.removeEventListener('mouseleave', this.onPointerLeave);

        this.resizeObserver?.disconnect();
        instances.delete(this.bar);
      }
    }

    function initBar(bar) {
      if (!bar || instances.has(bar)) return;

      const instance = new AnnouncementTicker(bar);
      instances.set(bar, instance);
    }

    function initAll(root = document) {
      if (root.matches?.('[data-announcement-bar]')) {
        initBar(root);
      }

      root
        .querySelectorAll?.('[data-announcement-bar]')
        .forEach(initBar);
    }

    function boot() {
      initAll(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    /*
      Shopify Theme Editor reloads section markup without a full page reload.
    */
    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      event.target
        .querySelectorAll?.('[data-announcement-bar]')
        .forEach((bar) => instances.get(bar)?.destroy());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-brand"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shop-by-brand-directory')) {
    customElements.define('shop-by-brand-directory', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.initialize(), {
            once: true,
            signal: this.controller.signal
          });
        } else {
          this.initialize();
        }
      }

      initialize() {
        const options = { signal: this.controller.signal };
        this.items = [...this.querySelectorAll('[data-brand-name]')];
        this.filters = [...this.querySelectorAll('[data-brand-filter]')];
        this.input = this.querySelector('[data-brand-search]');
        this.empty = this.querySelector('[data-brand-no-results]');
        this.status = this.querySelector('[data-brand-status]');
        this.activeLetter = 'all';
        this.querySelector('.shop-by-brand__search')?.removeAttribute('hidden');

        this.filters.forEach((button) => {
          button.disabled = button.dataset.brandFilter !== 'all' &&
            !this.items.some((item) => item.dataset.brandLetter === button.dataset.brandFilter);
          button.addEventListener('click', () => {
            this.activeLetter = button.dataset.brandFilter;
            this.filterBrands();
          }, options);
        });

        this.input?.addEventListener('input', () => this.filterBrands(), options);
        this.input?.addEventListener('search', () => this.filterBrands(), options);
        this.querySelector('[data-brand-reset]')?.addEventListener('click', () => {
          this.activeLetter = 'all';
          if (this.input) this.input.value = '';
          this.filterBrands();
          (this.input || this.filters[0])?.focus();
        }, options);
        this.filterBrands(false);
      }

      disconnectedCallback() {
        this.controller?.abort();
      }

      filterBrands(announce = true) {
        const query = (this.input?.value || '').trim().toLocaleLowerCase();
        let count = 0;
        this.items.forEach((item) => {
          const matchesLetter = this.activeLetter === 'all' || item.dataset.brandLetter === this.activeLetter;
          const matchesQuery = item.dataset.brandName.toLocaleLowerCase().includes(query);
          item.hidden = !(matchesLetter && matchesQuery);
          if (!item.hidden) count += 1;
        });
        this.filters.forEach((button) => {
          const active = button.dataset.brandFilter === this.activeLetter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
        if (this.empty) this.empty.hidden = count > 0 || (!query && this.activeLetter === 'all');
        if (this.status && announce) {
          this.status.textContent = this.status.dataset.resultsTemplate.replace('__COUNT__', String(count));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
